import axios from 'axios';
import store from '../store/store';
import { logout } from '../store/authSlice';

// In dev the Vite proxy forwards /api → localhost:8080, so a relative URL
// works without CORS. In prod the backend serves the SPA, so same-origin
// again works with a relative URL. No env var needed.
const api = axios.create({
    baseURL: '/api',
    timeout: 30000,
});

// Attach the JWT to every outgoing request.
api.interceptors.request.use((config) => {
    const token = store.getState().auth.accessToken;
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// On 401, clear the auth state. The router's protected-route logic will
// then push the user back to /login.
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            store.dispatch(logout());
        }
        return Promise.reject(error);
    },
);

export default api;

// Auth-specific helpers — keep the call sites readable.
export const authApi = {
    register: (email, password) =>
        api.post('/auth/register', { email, password }).then((r) => r.data),
    login: (email, password) =>
        api.post('/auth/login', { email, password }).then((r) => r.data),
};
